import {type OrderedMap} from 'immutable';

import {createAllActions, createAction} from 'web-app/util/redux/typed-action-helpers';
import type BehaviorsCollection from 'web-app/behaviors/behaviors-collection';

import {type ExtendedInquiry, type FetchInquiriesParams} from './types';

const domain = 'INQUIRIES';

export const {
    action: fetchInquiries,
    success: fetchInquiriesSuccess,
    failed: fetchInquiriesFailed,
} = createAllActions(
    `${domain}/FETCH_INQUIRIES`,
    (institutionId: string, params?: FetchInquiriesParams) => ({
        institutionId,
        params,
    }),
    (payload: {
        inquiries: OrderedMap<string, ExtendedInquiry>;
        behaviors: BehaviorsCollection;
        csv: string;
        total: number;
        nextOffset: number | null;
        lost: number;
        enrolled: number;
        showarounds: number;
    }) => payload,
);

// eslint-disable-next-line @typescript-eslint/no-empty-function
export const {action: clearInquiries} = createAction(`${domain}/CLEAR_INQUIRIES`, () => {});

export const {
    action: fetchMoreInquiries,
    success: fetchMoreInquiriesSuccess,
    failed: fetchMoreInquiriesFailed,
} = createAllActions(
    `${domain}/FETCH_MORE_INQUIRIES`,
    (institutionId: string, params?: FetchInquiriesParams) => ({
        institutionId,
        params,
    }),
    (payload: {inquiries: OrderedMap<string, ExtendedInquiry>; nextOffset: number | null}) => payload,
);
